export default __webpack_public_path__ + "static/media/a-3d1440.d6b0d27e.svg";